import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import logo from "../assets/images/logo.png";
import LoginSidebar from "../components/login-slider";
import googleicon from "../assets/images/google-icon.svg";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { useFormik } from "formik";
import * as Yup from "yup";
import MessageSnackbar from "../_layout/elements/snackbar";
import host from "../host";
import LoadingButton from "@mui/lab/LoadingButton";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { loginRequest } from "../authConfig";
import { msalConfig } from "../authConfig";
import { useDispatch } from "react-redux";
import { changeAuth } from "../actions/loginAction";
import * as msal from "msal";
import { useGoogleLogin } from "@react-oauth/google";
export const SignUpPage = () => {
  let loginResponse = null;
  const dispatch = useDispatch();
  const auth = localStorage.getItem("login") === "true";
  const location = useLocation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  var client = new msal.UserAgentApplication(msalConfig);
  const [isAzureValue, setIsAzureValue] = useState(false);

  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  const initiateLogin = async () => {
    try {
      setIsPopupOpen(true);
      loginResponse = await client.loginPopup(loginRequest);
      if (loginResponse) {
        setIsPopupOpen(false);
      }
      const account = loginResponse.account;
      formik.setFieldValue("name", account.name);
      formik.setFieldValue("email", account.userName);
      setIsAzureValue(true);
    } catch (e) {
      if (e.message === "User cancelled the flow.") {
        setSeverity("error");
        setMessage("Please finish sign-in process in Microsoft to continue");
        setSnackbar(true);
      } else {
        console.error(e);
      }
    }
  };

  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  let query = useQuery();
  let url_token = query.get("token");
  const defaultOptions = {
    loop: true,
    autoplay: true,
  };
  const [value, setValue] = useState();
  const initialTime = 60; // Initial countdown time in seconds
  const [timeLeft, setTimeLeft] = useState(initialTime);
  // Function to decrement the timer
  const decrementTimer = () => {
    setTimeLeft((prevTime) => prevTime - 1);
  };

  //sign-up functionality begins

  const recaptchaRef = React.createRef();
  const [captchaValue, setCaptchaValue] = useState("");
  const [recaptchaKey, setRecaptchaKey] = useState(1);
  function onChangeCaptcha(value) {
    setCaptchaValue(value);
  }

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email address").required("Email is required"),
    password: Yup.string().required("Password is required"),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });

  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    validationSchema: validationSchema,
  });

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [phoneError, setPhoneError] = useState("");
  const [phoneNo, setPhoneNo] = useState("");
  const [countryCode, setCountryCode] = useState("IN");
  const [otp, setOtp] = useState("");

  const [otpCount, setOtpCount] = useState(4);
  const [otpSent, setOtpSent] = useState(false);
  const signup = (values) => {
    if (phoneNo == "") {
      setPhoneError("Please provide valid phone");
      return;
    } else if (phoneNo.length != 13 && countryCode == "IN") {
      setPhoneError("Please provide valid phone");
      return;
    } else if (phoneNo.length < 7 || phoneNo.length > 16) {
      setPhoneError("Please provide valid phone");
      return;
    } else {
      setPhoneError("");
      values.phone = phoneNo.replace("+", "");
    }
    setLoading(true);

    fetch(host.chaturl + "/user/register", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        fullname: formik.values.name,
        email: formik.values.email,
        phone_number: phoneNo,
        password: formik.values.password,
        org: "",
      }),
    })
      .then(async (res) => {
        const data = await res.json();
        if (res.status === 400) {
          setLoading(false);
          setSeverity("error");
          setMessage(data.detail);
          setSnackbar(true);
        } else if (!res.ok) {
          setLoading(false);
          setSeverity("error");
          setOtpSent(false);
          setMessage(data.message);
          setSnackbar(true);
        } else {
          setLoading(false);
          setSeverity("success");
          setOtpSent(true);
          setMessage(otpCount === 4 ? "OTP sent successfully" : "OTP resent successfully");
          setOtpCount(otpCount - 1);
          setTimeLeft(20);

          const timerInterval = setInterval(() => {
            setTimeLeft((prevTimeLeft) => prevTimeLeft - 1);
          }, 1000);

          setTimeout(() => {
            clearInterval(timerInterval);
            setTimeLeft(0);
          }, 20000);
          setSnackbar(true);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
        setSeverity("error");
        setMessage("Something Went Wrong");
        setSnackbar(true);
      });
  };

  const verifyOtp = () => {
    if (!otp || otp.length !== 6) {
      setMessage("Enter a valid OTP");
      setLoading(false);
    } else {
      const decoded = decodeURIComponent(url_token);
      setLoading(true);
      setMessage("");
      let headers = { "Content-Type": "application/json" };
      if (url_token) {
        headers["x-token"] = decoded;
      }
      fetch(host.chaturl + "/user/verify_email", {
        method: "POST",
        headers: headers,
        // headers: { "Content-Type": "application/json", "x-token": url_token ? decoded : null },
        body: JSON.stringify({
          email: formik.values.email,
          otp: otp,
        }),
      })
        .then((res) => {
          setLoading(false);
          return res.json();
        })
        .then((data) => {
          if (data.success) {
            dispatch(changeAuth(true, data.token));
          } else if (data[0].success === false && data[1] === 500) {
            setSeverity("error");
            setMessage("Invalid token");
            setSnackbar(true);
          } else {
            setSeverity("error");
            setMessage("Something went wrong");
            setSnackbar(true);
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error.message === "400") {
            setMessage("Token invalid");
          } else {
            setMessage("An error occurred");
          }
        });
    }
  };

  //sign-up functionality ends

  //google login starts
  const googleLogin = (tokenResponse) => {
    setMessage("");
    setLoading(true);
    fetch(host.chaturl + "/user/google", {
      method: "POST",
      body: JSON.stringify({ credential: tokenResponse }),
      headers: {
        "Content-type": "application/json",
      },
    })
      .then(async (res) => {
        if (res.status === 401) {
          return res.json().then((data) => {
            throw new Error(data.message);
          });
        } else {
          return res.json();
        }
      })
      .then(async (data) => {
        setLoading(false);
        if (data.success) {
          dispatch(changeAuth(true, data.token));
          if (data.user) {
            dispatch(changeAuth(true, data.token));
          } else {
            setMessage("something went wrong");
          }
        } else {
          setMessage(data.message);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const loginGoogle = useGoogleLogin({
    onSuccess: (tokenResponse) => {
      googleLogin(tokenResponse);
    }
  });
  //google login ends

  useEffect(() => {
    if (auth) {
      //Redirect url logic is added because if user is not logged in and tries to access a page which is protected then after login user should be redirected to that page (used for share chat)
      const redirectUrl = location.state?.redirect ? location.state?.redirect : "/home";
      navigate(redirectUrl);
    }
  }, [auth]);

  useEffect(() => {
    if (url_token) {
      initiateLogin();
    }
  }, [url_token]);

  return (
    <div>
      {isPopupOpen &&
        ReactDOM.createPortal(
          <div style={{ color: "red", position: "fixed", top: "0", left: "0", width: "100%", padding: "1em", zIndex: 1000, textAlign: "center", fontSize: "20px" }}>
            Please complete the Microsoft sign-in process to continue. If you do not see the sign-in popup, check if your browser is blocking it.
          </div>,
          document.body
        )}
      <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      <div className={`background ${isPopupOpen ? "blur" : ""}`}>
        <div className="auth-page">
          <div className="container-fluid p-0">
            <div className="row g-0">
              <div className="col-xxl-6 col-lg-6 col-md-6">
                <LoginSidebar />
              </div>
              <div className="col-xxl-6 col-lg-6 col-md-6">
                <div className="auth-full-page-content d-flex p-sm-4 p-4">
                  <div className="form-width login-width">
                    <div className="d-flex flex-column h-100">
                      <div className="auth-content my-auto logincorporate">
                        <div className="mb-4 mb-md-4 text-center">
                          <div className="flip-logo">
                            <Link to={isPopupOpen ? "#" : "/"}>
                              <img className=" " src={logo} height={50} />
                            </Link>
                          </div>
                        </div>
                        <div className="welcometext text-center">
                          <h5 className="mb-0">Welcome </h5>
                          <p className="text-muted mt-2">Ngnext - KnowledgeHub : Conversations Beyond Boundaries</p>
                        </div>
                        <div className="mt-4 mb-2">
                          <div className="  other-login-options">
                            <Link
                              to="#"
                              className="  btn-google  "
                              onClick={(e) => {
                                e.preventDefault();
                                setLoading(true);
                                loginGoogle();
                              }}
                            >
                              <span className="">
                                {" "}
                                <img src={googleicon} alt="" />{" "}
                              </span>{" "}
                              Continue with Google{" "}
                            </Link>
                            {/* 
                                 <Link to="#" className='  btn-google  ' >
                                 <span className="" > <img src={microsofticon} alt='' />  </span>  Microsoft
                                 </Link>
                                 <Link to="#" className='  btn-google  ' >
                                 <span className="" > <img src={facebook} alt='' />  </span> Fecabook  </Link>
                                 <Link to="#" className='  btn-google  ' >
                                 <span className="" > <img src={apple} alt='' />  </span>  Apple
                                 </Link> */}
                          </div>
                        </div>
                        <div className="d-flex align-items-center mt-3  ">
                          <hr className="flex-grow-1 bg-dark-4" />
                          <span className="mx-2 text-2 text-muted">OR </span>
                          <hr className="flex-grow-1 bg-dark-4" />
                        </div>
                        <form className=" mt-2  " action="index.html">
                          <div className="row">
                            <div className="col-xxl-12 col-lg-12 col-md-12">
                              <div className="form-group">
                                <label className="form-label">
                                  {" "}
                                  Name <span className="text-danger">*</span>
                                </label>
                                <TextField
                                  size="small"
                                  type="text"
                                  placeholder="Enter your name"
                                  name="name"
                                  disabled={loading || isAzureValue || isPopupOpen}
                                  value={formik.values.name}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={formik.touched.name && Boolean(formik.errors.name)}
                                  helperText={formik.touched.name && formik.errors.name}
                                />
                              </div>
                            </div>
                            <div className="col-xxl-12 col-lg-12 col-md-12">
                              <div className="form-group">
                                <label className="form-label">
                                  {" "}
                                  Email <span className="text-danger">*</span>
                                </label>
                                <TextField
                                  size="small"
                                  type="text"
                                  placeholder="Enter mail ID"
                                  name="email"
                                  disabled={loading || isAzureValue || isPopupOpen}
                                  value={formik.values.email}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={formik.touched.email && Boolean(formik.errors.email)}
                                  helperText={formik.touched.email && formik.errors.email}
                                />
                              </div>
                            </div>
                            <div className="col-xxl-12 col-lg-12 col-md-12">
                              <div className="form-group">
                                <label className="form-label">
                                  Phone Number <span className="text-danger">*</span>
                                </label>
                                <PhoneInput
                                  size="small"
                                  className="worldwidephone"
                                  international
                                  countryCallingCodeEditable={false}
                                  value={phoneNo}
                                  disabled={loading || isPopupOpen}
                                  onChange={(e) => {
                                    setPhoneNo(e ? e : "");
                                  }}
                                  defaultCountry="IN"
                                  onCountryChange={(e) => {
                                    setCountryCode(e);
                                  }}
                                />
                                {phoneError && phoneError.length > 0 && (
                                  <span
                                    style={{
                                      color: "#d32f2f",
                                    }}
                                  >
                                    {phoneError}
                                  </span>
                                )}
                              </div>
                            </div>
                            <div className="col-xxl-6 col-lg-6 col-md-6 col-12">
                              <div className="form-group">
                                <label className="form-label">
                                  Password <span className="text-danger">*</span>
                                </label>
                                <TextField
                                  size="small"
                                  type={showPassword ? "text" : "password"}
                                  placeholder="Enter Password"
                                  name="password"
                                  disabled={loading || isPopupOpen}
                                  value={formik.values.password}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={formik.touched.password && Boolean(formik.errors.password)}
                                  helperText={formik.touched.password && formik.errors.password}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton onClick={() => setShowPassword(!showPassword)} onMouseDown={() => setShowPassword(!showPassword)}>
                                          {showPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </div>
                            </div>
                            <div className="col-xxl-6 col-lg-6 col-md-6 col-12">
                              <div className="form-group">
                                <label className="form-label">
                                  Confirm Password <span className="text-danger">*</span>
                                </label>
                                <TextField
                                  size="small"
                                  type={showConfirmPassword ? "text" : "password"}
                                  placeholder="Confirm Password"
                                  name="confirmPassword"
                                  disabled={loading || isPopupOpen}
                                  value={formik.values.confirmPassword}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  error={formik.touched.confirmPassword && Boolean(formik.errors.confirmPassword)}
                                  helperText={formik.touched.confirmPassword && formik.errors.confirmPassword}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} onMouseDown={() => setShowConfirmPassword(!showConfirmPassword)}>
                                          {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                                        </IconButton>
                                      </InputAdornment>
                                    ),
                                  }}
                                />
                              </div>
                            </div>
                            {/* <div className="col-xxl-12 col-lg-12 col-md-12">
                                    <div className="form-group">
                                       <span className="error text-danger mt-2" id="confirm_password_error" > Password Not Match</span>
                                       <span className="error text-success mt-2" id="confirm_password_error" > Password   Matched</span>
                                    </div>
                                 </div> */}
                            {/* <div className="col-xxl-12 col-lg-12 col-md-12">
                            <div className="form-group">
                              <ReCAPTCHA
                                key={recaptchaKey}
                                ref={recaptchaRef}
                                sitekey="6LewY0kpAAAAAGsTzqCaW0fDlCm9Al3yuDwmWuIu"
                                onChange={onChangeCaptcha}
                              />
                            </div>
                          </div> */}
                            <div className="col-xxl-12 col-lg-12 col-md-12" style={{ display: otpSent ? "block" : "none" }}>
                              <div className="form-group">
                                <label className="form-label">Email OTP</label>

                                <TextField
                                  size="small"
                                  type="text"
                                  value={otp}
                                  onChange={(e) => {
                                    setOtp(e.target.value);
                                  }}
                                  placeholder="Enter OTP"
                                />

                                <div className="resentotp mt-2 d-flex justify-content-between">
                                  <span className="text-muted">
                                    {otpCount > 0 ? (
                                      timeLeft > 0 ? (
                                        <small>
                                          Resend OTP in <b>{timeLeft}</b> sec
                                        </small>
                                      ) : (
                                        <Link
                                          to=""
                                          onClick={(e) => {
                                            e.preventDefault();
                                            signup(formik.values);
                                          }}
                                        >
                                          <small>Resend OTP</small>
                                        </Link>
                                      )
                                    ) : null}
                                  </span>
                                  <span className="otpcount">
                                    <small>
                                      {otpCount > 0 ? (
                                        <p>
                                          Resend attempts left: <b> {otpCount}</b>
                                        </p>
                                      ) : (
                                        <p className="text-danger">Maximum resend attempts reached</p>
                                      )}
                                    </small>
                                  </span>
                                </div>
                              </div>
                            </div>
                            <div className="col-xxl-12 col-lg-12 col-md-12">
                              <div className="form-group">
                                <LoadingButton
                                  style={{ textTransform: "capitalize" }}
                                  disabled={!formik.isValid || isPopupOpen}
                                  type="button"
                                  variant="contained"
                                  className="btn btn-primary w-100  "
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (!otpSent) {
                                      signup(formik.values);
                                    } else {
                                      verifyOtp();
                                    }
                                  }}
                                  controlled={true}
                                  loading={loading}
                                >
                                  {otpSent ? "Submit" : "Next"}
                                </LoadingButton>
                              </div>
                            </div>
                          </div>
                        </form>
                        <div className="  text-center notmember">
                          <p className="text-muted mb-0">
                            {" "}
                            Already have an account ?
                            <Link to={isPopupOpen ? "#" : "/login"} className=" fw-semibold">
                              {" "}
                              Login{" "}
                            </Link>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
